import request from '@/utils/request'
import { v2Host } from '@/config/host'
import { cookRequestParams } from '@/common/request'
import { DemandList, SaveDemand, Payment } from '@/types/demand/index.type'
import _ from 'lodash'

// http://playable.dev.com:8067/?doc=demand/api%2fdemand%2fdemand.go

export function fetchDemandList(params: DemandList) {
  return request({
    url: `${v2Host}/demand/demand/list`,
    method: 'get',
    params: cookRequestParams(params),
  })
}

export function fetchDemandAllList(params: DemandList) {
  return request({
    url: `${v2Host}/demand/demand/list-all`,
    method: 'get',
    params: cookRequestParams(params),
  })
}

export function fetchDemandStatistic() {
  return request({
    url: `${v2Host}/demand/demand/statistic`,
    method: 'get',
  })
}

export function fetchAssignDemandStatistic() {
  return request({
    url: `${v2Host}/demand/demand/assign-statistic`,
    method: 'get',
  })
}

export function createDemand(data: SaveDemand) {
  return request({
    url: `${v2Host}/demand/demand/create`,
    method: 'post',
    data,
  })
}

export function submitDemand(id: number) {
  return request({
    url: `${v2Host}/demand/demand/submit?id=${id}`,
    method: 'post',
  })
}

export function deleteDemand(id: number) {
  return request({
    url: `${v2Host}/demand/demand/del?id=${id}`,
    method: 'get',
  })
}

export function revocationDesigner(id: number | string) {
  return request({
    url: `${v2Host}/demand/demand/revocation-designer?id=${id}`,
    method: 'post',
  })
}

export function revocationDemand(id: number) {
  return request({
    url: `${v2Host}/demand/demand/revocation?id=${id}`,
    method: 'post',
  })
}

export function rejectDemand(
  id: number | string,
  data: {
    reject_reason: string
  },
) {
  return request({
    url: `${v2Host}/demand/demand/reject?id=${id}`,
    method: 'post',
    data: data,
  })
}

export function fetchDemandDetail(id: number) {
  return request({
    url: `${v2Host}/demand/demand/info?id=${id}`,
    method: 'get',
  })
}

export function assignmentDemand(
  id: number | string,
  data: {
    difficulty: string
    planner_id: number
    designer_id: number
    work_hours: number
    work_days: number
    estimated_time: string
    skip_plan: number
  },
) {
  return request({
    url: `${v2Host}/demand/demand/assign?id=${id}`,
    method: 'post',
    data: data,
  })
}

export function deliverDemand(data: {
  id: number
  creations: {
    channel_id: number
    attachment_url: string
    name: string
    id?: number
    material_tag_ids?: string
    scene_num?: number
  }[]
  meta_pl: string
  meta_cl: string
  meta_tc: string
}) {
  return request({
    url: `${v2Host}/demand/demand/deliver`,
    method: 'post',
    data: data,
  })
}

export function updateDemand(id: number, data: SaveDemand) {
  return request({
    url: `${v2Host}/demand/demand/update?id=${id}`,
    method: 'post',
    data: data,
  })
}

export function fellAllAdvertisers(params: { keyword: string }) {
  return request({
    url: `${v2Host}/demand/demand/advertisers`,
    method: 'get',
    params: params,
  })
}

export function discardDemand(data: { id: number; reason: string }) {
  return request({
    url: `${v2Host}/demand/demand/discard?id=${data.id}`,
    method: 'post',
    data: {
      reason: data.reason,
    },
  })
}

export function adjustDemandOwner(data: {
  type: number
  ids: string
  owner_id: number
}) {
  return request({
    url: `${v2Host}/demand/demand/adjust-owner`,
    method: 'post',
    data: cookRequestParams(data),
  })
}

export function updatePayment(data: {
  id: number
  is_pay: number
  payment?: Payment
}) {
  return request({
    url: `${v2Host}/demand/demand/update-payment`,
    method: 'post',
    data,
  })
}

export function updateSupplementPayment(data: {
  payment_id: number
  cost: number
  revenue: number
}) {
  return request({
    url: `${v2Host}/demand/demand/supplement-payment`,
    method: 'post',
    data,
  })
}

export function pushDemand(data: { id: number; adv_id: number }) {
  return request({
    url: `${v2Host}/demand/demand/push`,
    method: 'post',
    data,
  })
}

export function updateTemplate(data: { id: number; basic_file?: string }) {
  return request({
    url: `${v2Host}/demand/demand/update-template?id=${data.id}`,
    method: 'post',
    data: _.omit(data, ['id']),
    withoutError: 1,
  })
}

export function genBill(data: { demand_id: number }) {
  return request({
    url: `${v2Host}/demand/demand/gen-bill`,
    method: 'post',
    data,
  })
}

export function checkPending(params: { type: string; id: number }) {
  return request({
    url: `${v2Host}/demand/demand/check-pending`,
    method: 'get',
    params: cookRequestParams(params),
  })
}
